import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import { orderMobx } from 'restaurant'
import { cartMobx, mallMobx } from 'mobx/mall'
import { format, deepClone } from '@dt/fe-utils'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { Avatar } from '@cps'
import ProductItem from './ProductItem'
import MultiProductItem from './MultiProductItem'
import './index.scss'

const CheckoutProduct: FC = () => {
  const menuProductsMap = useMemo(() => {
    return keyBy(mallMobx.products, 'no')
  }, [mallMobx.products])

  const getNewItem = (item) => {
    const newItem = deepClone(item)
    if (mallMobx.products.length) {
      newItem.pic = menuProductsMap[item.productNo].pic
    }
    return newItem
  }

  const formatProductItemArr = (arr) => {
    const _obj = {}
    const newArr = []
    arr.sort((a, b) => b.addTimeStamp - a.addTimeStamp).map(item => {
      const time = item.addTime.split(' ').join('')
      if (!_obj[time]) {
        _obj[time] = []
      }
      _obj[time].push(item)
    })

    Object.values(_obj).map((value: any[]) => {
      if (!value.length) return
      if (value.length === 1) {
        newArr.push(value[0])
      } else {
        newArr.push(value)
      }
    })

    return newArr
  }

  const newProductItemArr = (item, isMulti: boolean) => {
    return (
      <div key={item.detailId}>
        {
          isMulti ? (
            <>
              <MultiProductItem
                item={getNewItem(item)}
              />
              <div className='add-user'>
                {item.addUsers?.map((user) => {
                  return <Avatar key={user} userKey={user} />
                })}
              </div>
            </>
          ) : (
            <ProductItem
              key={item.detailId}
              item={getNewItem(item)}
            />
          )
        }
      </div>
    )
  }

  return (
    <div className='mall-checkout-product'>
      <div className='mall-checkout-product-list'>
        <>
          {
            /** 单人点餐订单 */
            formatProductItemArr(cartMobx.viewOrderItems).map((orderItem, index) => {
              const isArray = Array.isArray(orderItem)
              return (
                <div className='mall-checkout-product-newItem' key={isArray ? orderItem[0].detailId : orderItem.detailId}>
                  <p className='time'>{format.toDateTime(isArray ? orderItem[0].addTime : orderItem.addTime)}{i18n.t('cart.placeOrder')}</p>
                  {isArray ? orderItem.map(item => newProductItemArr(item, false)) : newProductItemArr(orderItem, false)}
                </div>
              )
            })
          }
          {/* 单人点餐购物车 */}
          {
            orderMobx.viewOrder.isWait && cartMobx.viewCartItems
              .filter((item) => item.cnt && !item.disabled)
              .map((cartItem) => {
                const status = cartMobx.info.payMode ? 'WAIT_CONFRIM' : null
                return (
                  <div key={cartItem.pk}>
                    <ProductItem status={status} item={getNewItem(cartItem)} />
                  </div>
                )
              })
          }
        </>
      </div>
    </div>
  )
}

export default observer(CheckoutProduct)
